<ng-content select="*:not([onsip-header-secondary-action])"></ng-content>
<onsip-spacer></onsip-spacer>
<ng-content select="*[onsip-header-secondary-action]"></ng-content>
